import { ListContentIsland } from '@razz-team/ui-web';
import { CurrencyRateListItem } from '../../ListItem/CurrencyRateListItem';
import { useAccountQuery } from '../../../api/accounts';
import { useBalanceRate } from '../../../api/transfers';

export function AccountExchangeRate({ accountId }: { accountId: string }) {
  const accountQuery = useAccountQuery({ accountId });
  const balanceRate = useBalanceRate(accountQuery.data?.balance);

  return (
    <ListContentIsland>
      <CurrencyRateListItem
        rate={balanceRate?.rate}
        currency={accountQuery.data?.balance.currency}
      />
    </ListContentIsland>
  );
}
